/**
 * Deterministic device type detection — UA + viewport, no ML.
 * Returns: "desktop" | "mobile" | "tablet" | "glasses" | "unknown"
 */
export function detectDevice() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent || '';
  const w  = window.innerWidth  || 1024;

  // XR / glasses first — highest specificity
  if (/OculusBrowser|Meta Quest|visionOS|HoloLens|\bXR\b|MagicLeap/i.test(ua)) return 'glasses';

  // Mobile phones
  if (/Mobi|Android.*Mobile|iPhone|iPod/i.test(ua)) return 'mobile';

  // Tablets
  if (/iPad|Android(?!.*Mobile)/i.test(ua) || (w >= 600 && w < 1024)) return 'tablet';

  // Narrow viewport on desktop browser is still desktop
  if (w < 480) return 'mobile';

  return 'desktop';
}

/**
 * Persist a stable device ID in localStorage.
 * Re-generates if missing — survives page reloads.
 */
export function generateDeviceId() {
  try {
    let id = localStorage.getItem('_doar_device_id');
    if (!id) {
      id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem('_doar_device_id', id);
    }
    return id;
  } catch {
    return `tmp_${Math.random().toString(36).slice(2)}`;
  }
}
